export default "__VITE_ASSET__eAGCD0he__"